window.lazySizesConfig = window.lazySizesConfig || {};
// The expand option expands the calculated visual viewport area in all directions,
// so that elements can be loaded before they become visible.
// The default value is calculated depending on the viewport size of the device.
// (Note: Reasonable values are between 300 and 1000
window.lazySizesConfig.expand = 300;
window.lazySizesConfig.loadHidden = false;
require('lazysizes');
require('lazysizes/plugins/unveilhooks/ls.unveilhooks');
